import { useEffect, useState } from 'react';
import { BASE_URL } from '../url';
import LoadingSpinner from './LoadingSpinner';
import SiteLayout, { PageHero } from './SiteLayout';
import { BiCalendarAlt } from 'react-icons/bi';

function imageFunction(imageURL) {
  if (!imageURL) return '';
  const pathArray = imageURL.split('/');
  return pathArray[5] ? `https://drive.google.com/uc?id=${pathArray[5]}` : imageURL;
}

function getDate(createdDate) {
  if (!createdDate) return 'Recently published';
  return new Date(createdDate).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

function NewsPage() {
  const [viewAllNews, setViewAllNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/viewAllNews`)
      .then((response) => response.json())
      .then((data) => setViewAllNews(Array.isArray(data) ? data : []))
      .catch(() => setViewAllNews([]))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="News" title="Stories of support, care, and community action">
          See recent events and updates from Raising Smiles.
        </PageHero>

        <section className="section-padding news-listing-section">
          <div className="container">
            {isLoading && <LoadingSpinner compact />}
            {!isLoading && viewAllNews.length === 0 && (
              <div className="empty-state">
                <h2>No news available yet</h2>
                <p>Published updates will appear here once the team adds them.</p>
              </div>
            )}
            {!isLoading && viewAllNews.length > 0 && (
              <div className="news-list">
                {viewAllNews.map((newsData) => (
                  <article className="news-feature" key={newsData._id || newsData.postHeading}>
                    <img src={imageFunction(newsData.imageURL)} alt={newsData.postHeading} loading="lazy" />
                    <div className="news-feature-content">
                      <span className="news-date"><BiCalendarAlt aria-hidden="true" /> {getDate(newsData.createdAt)}</span>
                      <h2>{newsData.postHeading}</h2>
                      <p>{newsData.postDetails}</p>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}

export default NewsPage;
